import { clsx } from 'clsx'
import { useBranding } from '../store/branding'

/** Site logo + name, sourced from admin-set branding. Falls back to CSS drip cyber logo + optional generated mark. */
export function Brand({ size = 'md', className }: { size?: 'sm' | 'md' | 'lg'; className?: string }) {
  const branding = useBranding((s) => s.branding)
  const textSize = size === 'lg' ? 'text-5xl sm:text-6xl' : size === 'sm' ? 'text-2xl' : 'text-3xl'
  const logoSize = size === 'lg' ? 'h-10 w-10' : size === 'sm' ? 'h-6 w-6' : 'h-8 w-8'
  return (
    <span className={clsx('inline-flex items-center gap-2.5', className)}>
      {branding.logoUrl ? (
        <img
          src={branding.logoUrl}
          alt=""
          className={clsx(logoSize, 'rounded border border-edge object-cover shadow-neon-pink')}
          onError={(e) => (e.currentTarget.style.display = 'none')}
        />
      ) : (
        <img src="/assets/goongallery-promo.jpg" alt="" className={clsx(logoSize, 'rounded-sm object-cover opacity-90 shadow-neon-pink')} />
      )}
      <span
        className={clsx('drip-logo leading-none text-white', textSize)}
        data-text={branding.name || 'GOON GALLERY'}
      >
        {branding.name || 'GOON GALLERY'}
      </span>
    </span>
  )
}
